import { render, staticRenderFns } from "./Warnings.vue?vue&type=template&id=35e447ed"
import script from "./Warnings.vue?vue&type=script&lang=js"
export * from "./Warnings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports